// Shared style tokens for buttons / inputs across marketing pages (LIGHT theme)
export const btnPrimary =
  "inline-flex items-center justify-center gap-2 rounded-full bg-lime px-7 py-3.5 text-sm font-semibold text-ink transition-all duration-300 hover:bg-ink hover:text-white";

export const btnOutline =
  "inline-flex items-center justify-center gap-2 rounded-full border border-ink/20 px-7 py-3.5 text-sm font-medium text-ink transition-all duration-300 hover:bg-ink hover:border-ink hover:text-white";

export const btnGhost =
  "inline-flex items-center justify-center gap-2 rounded-full border border-ink/15 px-5 py-2.5 text-xs font-medium uppercase tracking-[0.15em] text-ink/70 transition-colors duration-300 hover:text-ink hover:border-ink/40";

export const inputCls =
  "w-full rounded-none border-0 border-b border-ink/15 bg-transparent px-0 py-3 text-base text-ink placeholder:text-ink/35 transition-colors duration-300 focus:border-lime-dim focus:outline-none focus:ring-0";

export const labelCls =
  "mb-1 block text-[11px] uppercase tracking-[0.2em] text-ink/50";

export const overline =
  "text-[11px] uppercase tracking-[0.28em] text-lime-dim font-semibold";
